/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

/**
 * Proval API
 * This is the Proval API!
 *
 * OpenAPI spec version: 0.1.0-alpha.182
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Links} from './links';
import {Township} from './township';
import {ThirdParty} from './third-party';
import {PhoneNumber} from './phone-number';
import {Tour} from './tour';


export interface RemovalPoint {
  coordinatesId: number;
  thirdPartyId: number;
  tourId: number;
  townshipId: number;
  id: number;
  address: string;
  address2?: string;
  allAddress?: string;
  callBeforeTime: number;
  comments?: string;
  enabled: boolean;
  favorite: boolean;
  name: string;
  zipAndTownship?: string;
  mobilePhones: Array<PhoneNumber>;
  phones: Array<PhoneNumber>;
  _links?: Links;
  _embedded?: {
    coordinates?: any;
    thirdParty?: ThirdParty;
    tour?: Tour;
    township?: Township;
  };
}

export function EmptyRP(): RemovalPoint {
  return {
    coordinatesId: null,
    thirdPartyId: null,
    tourId: null,
    townshipId: null,
    id: null,
    address: null,
    address2: null,
    allAddress: null,
    callBeforeTime: null,
    comments: null,
    enabled: true,
    favorite: false,
    name: null,
    zipAndTownship: null,
    mobilePhones: [],
    phones: [],
    _embedded: {
      coordinates: null,
      thirdParty: null,
      tour: null,
      township: null
    }
  };
}
